import { render } from "./Facturas.vue?vue&type=template&id=1f2d9a72&scoped=true"
import script from "./Facturas.vue?vue&type=script&lang=ts"
export * from "./Facturas.vue?vue&type=script&lang=ts"

import "./Facturas.vue?vue&type=style&index=0&id=1f2d9a72&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1f2d9a72"

export default script